import { render, staticRenderFns } from "./HomeApproval.vue?vue&type=template&id=6aad518c"
import script from "./HomeApproval.vue?vue&type=script&lang=js"
export * from "./HomeApproval.vue?vue&type=script&lang=js"
import style0 from "./HomeApproval.vue?vue&type=style&index=0&id=6aad518c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports